module.exports = __webpack_public_path__ + "img/algeria.724dbd69.svg";